import   axios                                        from 'axios';

import { API_URLS                                  }  from '../urls';

import { BackendResponse                           ,
         handleError                               }  from '../../dataTypes/backendServicesManagment/types';

import { DetailledIpAddressInformations }  from '../../dataTypes/networkManagment/types';

import { convertStringToDate                       }  from '../../dataTypes/timeManagment/utils';

const transformUser = (data: any) => ({
  id                  : data.user_id,
  creationDate        : convertStringToDate(data.user_creationDate),
  creationIpAddress   : data.user_creationIpAddress,
  email               : data.user_email,
  emailValidationDate : convertStringToDate(data.user_emailValidationDate),
  status              : data.user_status,
  statusDeadline      : convertStringToDate(data.user_statusDeadline),
  locked              : false,

  nextStatus                                      : '',
  nextStatusRequestDate                           : null ,
  nextStatusRequestIpAddress                      : '',
  state                                           : '',
  closureDate                                     : null ,
  closureIpAddress                                : '',
  lastBanDate                                     : null ,
  lastUpdateIpAddress                             : '',
  lastUpdateDate                                  : null ,
  emailValidationToken                            : '',
  emailValidationIpAddress                        : '',
  emailValidationReminder                         : '',
  lastPasswordResetRequestIpAddress               : '',
  lastPasswordResetRequestDate                    : null ,
  lastPasswordResetToken                          : '',
  lastPasswordResetIpAddress                      : '',
  lastPasswordResetDate                           : null ,
  lastEmailResetRequestIpAddress                  : '',
  lastEmailResetRequestDate                       : null ,
  lastEmailResetToken                             : '',
  lastEmailResetIpAddress                         : '',
  lastEmailResetDate                              : null ,
  lastEmailResetPreviousEmail                     : '',
  lastEmailResetPreviousEmailValidationToken      : '',
  lastEmailResetPreviousEmailValidationIpAddress  : '',
  lastEmailResetPreviousEmailValidationDate       : null ,

    ipApiCom_country       : ''      ,
  ipApiCom_city          : ''      ,
  ipApiCom_lat           : 0      ,
  ipApiCom_lon           : 0      ,
  ipApiCom_isp           : ''      ,


  firstname           : data.user_firstname,
  lastname            : data.user_lastname,
  sex                 : data.user_sex,
  birthday            : convertStringToDate(data.user_birthday),
  address             : data.user_address,
  address2            : data.user_address2,
  address3            : data.user_address3,
  zipCode             : data.user_zipCode,
  city                : data.user_city,
  country             : data.user_country,
  phoneNumber         : data.user_phoneNumber,

  lastLoginDate       : convertStringToDate(data.user_lastLoginDate),
  lastLoginIpAddress  : data.lastLoginIpAddress,
  lastLoginCity       : data.lastLoginCity,
  
  purchases           : [],
});

const transformUserAgent = (data: any) => ({
  browserName     : data.userAgent_browserName,
  browserVersion  : data.userAgent_browserVersion,
  browserMajor    : data.userAgent_browserMajor,
  browserType     : data.userAgent_browserType,
  engineName      : data.userAgent_engineName,
  engineVersion   : data.userAgent_engineVersion,
  osName          : data.userAgent_osName,
  osVersion       : data.userAgent_osVersion,
  deviceType      : data.userAgent_deviceType,
  deviceVendor    : data.userAgent_deviceVendor,
  deviceModel     : data.userAgent_deviceModel,
  cpuArchitecture : data.userAgent_cpuArchitecture,
});

const transformResponse = (data: any) => {

  const parseDate = (date: any) => {

    if (date && typeof date === 'string') {
      return convertStringToDate(date);
    }
    return null;
  };

  return {
    ipAddress              : data.ipAddress,
    creationDate           : parseDate(data.creationDate?.date),  // Passez à convertStringToDate seulement si la date est valide
    ipApiCom_query         : data.ipApiCom_query,
    ipApiCom_status        : data.ipApiCom_status,
    ipApiCom_continent     : data.ipApiCom_continent,
    ipApiCom_continentCode : data.ipApiCom_continentCode,
    ipApiCom_country       : data.ipApiCom_country,
    ipApiCom_countryCode   : data.ipApiCom_countryCode,
    ipApiCom_region        : data.ipApiCom_region,
    ipApiCom_regionName    : data.ipApiCom_regionName,
    ipApiCom_city          : data.ipApiCom_city,
    ipApiCom_district      : data.ipApiCom_district,
    ipApiCom_zip           : data.ipApiCom_zip,
    ipApiCom_lat           : data.ipApiCom_lat,
    ipApiCom_lon           : data.ipApiCom_lon,
    ipApiCom_timezone      : data.ipApiCom_timezone,
    ipApiCom_offset        : data.ipApiCom_offset,
    ipApiCom_currency      : data.ipApiCom_currency,
    ipApiCom_isp           : data.ipApiCom_isp,
    ipApiCom_org           : data.ipApiCom_org,
    ipApiCom_as            : data.ipApiCom_as,
    ipApiCom_asname        : data.ipApiCom_asname,
    ipApiCom_reverse       : data.ipApiCom_reverse,
    ipApiCom_mobile        : data.ipApiCom_mobile,
    ipApiCom_proxy         : data.ipApiCom_proxy,
    ipApiCom_hosting       : data.ipApiCom_hosting,
    user                   : transformUser(data),
    userAgent              : transformUserAgent(data),
  };
};

export interface BackendResponse_DetailledIpAddressInformations extends BackendResponse<DetailledIpAddressInformations> {}

export const getDetailledIpAddressInformationsWithIp = async ( ipAddress : string ,
                                                               user?     : number ): Promise<BackendResponse_DetailledIpAddressInformations> => {
  const baseUrl = `${API_URLS.getDetailledIpAddressInformationsWithIp}?`;
  const url = user !== undefined
    ? `${baseUrl}analyzedIpAddress=${encodeURIComponent(ipAddress)}&userId=${encodeURIComponent(user)}`
    : `${baseUrl}analyzedIpAddress=${encodeURIComponent(ipAddress)}`;

  try
   {
    const response = await axios.get(url);

    if (response.status === 200)
          {
           const data = transformResponse(response.data);

           return {
                    code: 1,
                    comment: 'Les informations IP ont été récupérées avec succès.',
                    payload: data,
                  };
          }
     else {
           return handleError<DetailledIpAddressInformations>(response.status, 'Réponse non-200 de l\'API');
          }
   }
  catch (error)
   {
    console.log(url, error);

    if (axios.isAxiosError(error))
     {
      return handleError<DetailledIpAddressInformations>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<DetailledIpAddressInformations>(-102, 'Erreur inconnue');
  }
};

export interface BackendResponse_DetailledIpAddressInformationsArray extends BackendResponse<DetailledIpAddressInformations[]> {}

export const getDetailledIpAddressInformations = async (): Promise<BackendResponse_DetailledIpAddressInformationsArray> => {

  const url = `${API_URLS.getDetailledIpAddressInformations}`;

  try
   {

    const response = await axios.get(url);


    if (response.status === 200 && Array.isArray(response.data))
          {
           const dataList = response.data.map((item: any) => transformResponse(item));

           return {
                   code: 1,
                   comment: 'Les informations IP ont été récupérées avec succès.',
                   payload: dataList,
                  };
          }
     else {
           return handleError<DetailledIpAddressInformations[]>(response.status, 'Réponse non-200 de l\'API ou données invalides.');
          }
   }
  catch (error)
   {
    if (axios.isAxiosError(error))
     {
      return handleError<DetailledIpAddressInformations[]>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<DetailledIpAddressInformations[]>(-102, 'Erreur inconnue');
   }
};
